import { useEffect } from "react";
import { motion, useScroll, useTransform, useMotionValue, useSpring } from "framer-motion";

const PUB = process.env.PUBLIC_URL || "";

const drinks = [
  { src: "/drinks/martini.png", cls: "top-[10%] right-[5%] w-[30vw] max-w-[400px]", depth: 40, dur: 7.5, rot: 6, glow: true },
  { src: "/drinks/coupe.png", cls: "bottom-[4%] right-[14%] w-[22vw] max-w-[320px]", depth: 55, dur: 8.5, rot: -7, glow: true },
  { src: "/drinks/highball.png", cls: "top-[26%] right-[34%] w-[15vw] max-w-[210px] hidden md:block", depth: 26, dur: 9.5, rot: 5 },
  { src: "/drinks/shaker.png", cls: "bottom-[16%] right-[38%] w-[10vw] max-w-[140px] hidden lg:block", depth: 70, dur: 6.5, rot: -9 },
];

function Drink({ d, mx, my, scrollY }) {
  const tx = useTransform(mx, (v) => v * d.depth);
  const ty = useTransform(my, (v) => v * d.depth);
  const py = useTransform(scrollY, (v) => v * (d.depth / 55));

  return (
    <motion.div style={{ x: tx, y: ty }} className={`absolute ${d.cls}`}>
      <motion.div style={{ y: py }}>
        {d.glow && (
          <div className="absolute inset-0 -z-10 blur-3xl bg-[radial-gradient(circle,rgba(212,175,55,0.28),transparent_65%)] scale-125" />
        )}
        <motion.img
          src={`${PUB}${d.src}`}
          alt=""
          aria-hidden
          draggable={false}
          animate={{ y: [0, -20, 0], rotate: [0, d.rot, 0] }}
          transition={{ duration: d.dur, repeat: Infinity, ease: "easeInOut" }}
          className="w-full h-auto select-none drop-shadow-[0_30px_55px_rgba(0,0,0,0.65)]"
        />
      </motion.div>
    </motion.div>
  );
}

export default function FloatingDrinks() {
  const { scrollY } = useScroll();
  const rawX = useMotionValue(0);
  const rawY = useMotionValue(0);
  const mx = useSpring(rawX, { stiffness: 45, damping: 18 });
  const my = useSpring(rawY, { stiffness: 45, damping: 18 });

  useEffect(() => {
    const onMove = (e) => {
      rawX.set(e.clientX / window.innerWidth - 0.5);
      rawY.set(e.clientY / window.innerHeight - 0.5);
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, [rawX, rawY]);

  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="hero-floating-drinks">
      {drinks.map((d, i) => (
        <Drink key={i} d={d} mx={mx} my={my} scrollY={scrollY} />
      ))}
    </div>
  );
}
